import gql from "graphql-tag";
import axios from "axios";

const CHECK_LOGIN_DETAILS = data =>
    axios.post(
        process.env.VUE_APP_HASURA_URL,
        {
            query: `query($mail: String!, $password: String) {
        spendmd_db_users(
            where: { email: { _eq: $mail } }
        ) {
            id
            name
            email
            added
            verification_pending
            account_disabled
            is_rejected
        }
    }
`,
            variables: {
                ...data
            }
        },
        {
            headers: {
                "X-Hasura-User-Id": data.id
            }
        }
    );

const RESET_PASSWORD = gql`
    mutation($id: uuid!, $mail: String!, $password: String!) {
        update_spendmd_db_users(
            where: { id: { _eq: $id }, email: { _eq: $mail } }
            _set: { password: $password }
        ) {
            returning {
                id
            }
        }
    }
`;

export default {
    CHECK_LOGIN_DETAILS,
    RESET_PASSWORD
};
